import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="100%" alt="Pizza Maru About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="600px"
          w="100%"
          image={`url(${about}) top / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          zIndex={90}
          column
          center
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
